import React from 'react';
import './SasaBackground.css';

const SasaBackground = () => {
  const sasaBranches = [
    { position: 'sasa-left-1', rotation: -15 },
    { position: 'sasa-left-2', rotation: -8 },
    { position: 'sasa-center-left', rotation: -3 },
    { position: 'sasa-center-right', rotation: 3 },
    { position: 'sasa-right-2', rotation: 8 },
    { position: 'sasa-right-1', rotation: 15 }
  ];

  return (
    <div className="sasa-background">
      <div className="sasa-container">
        {sasaBranches.map((branch, index) => (
          <div 
            key={index} 
            className={`sasa-branch ${branch.position}`}
            style={{ transform: `rotate(${branch.rotation}deg)` }}
          >
            <div className="sasa-stem"></div>
            <div className="sasa-leaves">
              {[...Array(8)].map((_, i) => (
                <div key={i} className={`sasa-leaf leaf-${i + 1}`}></div>
              ))}
            </div>
          </div>
        ))}
      </div>
      
      {/* 星空の背景 */}
      <div className="stars">
        {[...Array(50)].map((_, i) => (
          <div 
            key={i} 
            className="star"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${2 + Math.random() * 2}s`
            }}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default SasaBackground;